var Q = Object.defineProperty;
var Z = (f, e, l) => e in f ? Q(f, e, { enumerable: !0, configurable: !0, writable: !0, value: l }) : f[e] = l;
var T = (f, e, l) => (Z(f, typeof e != "symbol" ? e + "" : e, l), l);
import { inject as V, reactive as ee, ref as R, computed as o, readonly as te, unref as v, defineComponent as M, toRef as _, openBlock as g, createElementBlock as b, createCommentVNode as W, createElementVNode as $, normalizeStyle as G, toDisplayString as U, createBlock as j, onMounted as O, watch as le, provide as ae, Fragment as A, renderList as Y, renderSlot as oe, toRefs as ne } from "vue";
const se = 180 / Math.PI;
class t {
  constructor(e, l) {
    /**
     * The x component of the vector.
     */
    T(this, "x");
    /**
     * The y component of the vector.
     */
    T(this, "y");
    typeof e == "number" ? (this.x = e, this.y = e, typeof l == "number" && (this.y = l)) : Array.isArray(e) ? (this.x = e[0], this.y = e[1]) : typeof e == "object" ? (this.x = e.x, this.y = e.y) : (this.x = 0, this.y = 0);
  }
  /**
   * Wraps a value in a vector.
   *
   * If the value is already a vector, it is returned unchanged.
   *
   * @param value The value to wrap.
   */
  static wrap(e) {
    return e instanceof t ? e : new t(e);
  }
  /**
   * Creates a vector with length 1 from an angle with the x-axis.
   *
   * @param angle The angle of the vector with the x-axis in radians.
   */
  static fromAngle(e) {
    return new t(Math.cos(e), Math.sin(e));
  }
  /**
   * Creates a vector from polar coordinates.
   *
   * @param angle The angle of the vector with the x-axis in radians.
   * @param r The magnitude of the vector.
   */
  static fromPolar(e, l = 1) {
    return new t(l * Math.cos(e), l * Math.sin(e));
  }
  /**
   * Returns the angle of the vector with the x-axis in radians.
   */
  get angle() {
    return Math.atan2(this.y, this.x);
  }
  /**
   * Returns the angle of the vector with the x-axis in degrees.
   */
  get angleDegrees() {
    return this.angle * se;
  }
  /**
   * Returns the slope of the vector.
   */
  get slope() {
    return this.y / this.x;
  }
  /**
   * Returns the sum of this vector and the other.
   *
   * @param vector The other vector.
   */
  add(e) {
    const l = t.wrap(e);
    return new t(this.x + l.x, this.y + l.y);
  }
  /**
   * Returns the difference between this vector and the other.
   *
   * @param vector The other vector.
   */
  sub(e) {
    const l = t.wrap(e);
    return new t(this.x - l.x, this.y - l.y);
  }
  /**
   * Multiplies each component of the vector by the corresponding component of
   * the other vector.
   *
   * @param vector The other vector.
   */
  mul(e) {
    const l = t.wrap(e);
    return new t(this.x * l.x, this.y * l.y);
  }
  /**
   * Divides each component of the vector by the corresponding component of the
   * other vector.
   *
   * @param vector The other vector.
   */
  div(e) {
    const l = new t(e);
    return new t(this.x / l.x, this.y / l.y);
  }
  /**
   * Returns the dot product of this vector and another.
   *
   * @param vector The other vector.
   */
  dot(e) {
    const l = new t(e);
    return this.x * l.x + this.y * l.y;
  }
  /**
   * Scales both components of the vector by the given scalar.
   *
   * @param scalar The scalar to scale by.
   */
  scale(e) {
    return new t(this.x * e, this.y * e);
  }
  /**
   * Returns the magnitude of the vector.
   */
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y);
  }
  /**
   * Returns a vector with the same direction but a magnitude of 1.
   */
  normalized() {
    return new t(this.x / this.length(), this.y / this.length());
  }
  /**
   * Returns a vector with the same magnitude but opposite direction.
   */
  negate() {
    return new t(-this.x, -this.y);
  }
  /**
   * Returns a vector perpendicular to this one.
   */
  perpendicular() {
    return new t(this.y, -this.x);
  }
  /**
   * Rotates the vector by the given angle around the origin.
   *
   * @param angle The angle to rotate by in radians.
   */
  rotate(e) {
    const l = Math.cos(e), c = Math.sin(e);
    return new t(
      this.x * l - this.y * c,
      this.x * c + this.y * l
    );
  }
  /**
   * Sets the angle of the vector with the x-axis.
   *
   * This method mutates the vector.
   *
   * @param angle The angle between the vector and the x-axis in radians.
   */
  setAngle(e) {
    const l = this.length();
    this.x = l * Math.cos(e), this.y = l * Math.sin(e);
  }
  angleBetween(e) {
    return Math.acos(
      this.dot(e) / (this.length() * t.wrap(e).length())
    );
  }
  /**
   * Returns the distance between this vector and another.
   *
   * @param vector The other vector.
   */
  distanceTo(e) {
    return this.sub(t.wrap(e)).length();
  }
}
const N = Symbol();
function P() {
  const f = V(N);
  if (!f)
    throw new Error("Component is missing a parent <Graph> component.");
  return f;
}
const L = ee({
  light: {
    grid: "#ccc",
    units: "#aaa",
    axis: "#ccc",
    stroke: "#000",
    text: "#000",
    labelBackground: "#ffffffcc",
    points: "#000"
  },
  dark: {
    grid: "#646262",
    units: "#727171",
    axis: "#6f6f6f",
    stroke: "#f1f1f1",
    text: "#f1f1f1",
    labelBackground: "#222222cc",
    points: "#f1f1f1"
  }
}), q = R(!1), X = o(
  () => q.value ? L.dark : L.light
);
function re(f, e) {
  return o(() => {
    const l = v(f);
    return typeof l == "string" ? l : l === void 0 ? e === void 0 ? "none" : X.value[e] : q.value ? l.dark : l.light;
  });
}
function B() {
  return {
    parseColor: re,
    colors: te(X)
  };
}
const ie = ["transform"], ue = ["x", "y", "width", "height", "fill", "stroke"], de = ["x", "y", "fill"], F = /* @__PURE__ */ M({
  __name: "Label",
  props: {
    size: { default: "normal" },
    color: {},
    position: { default: () => new t() },
    rotation: { default: 0 },
    border: { type: Boolean, default: !0 },
    text: {}
  },
  setup(f) {
    const e = f, l = {
      small: 12,
      normal: 14,
      large: 16
    }, c = {
      small: 8,
      normal: 10,
      large: 12
    }, { scale: u, offset: p, invScale: m } = P(), { colors: n, parseColor: r } = B(), s = r(_(e, "color"), "stroke"), d = o(
      () => new t(e.position).mul(new t(1, -1)).mul(u.value).add(p.value)
    ), h = o(
      () => Math.max(
        (e.text.length + 1) * c[e.size],
        c[e.size] * 2.5
      ) * m.value
    ), w = o(
      () => Math.min(c[e.size] * 3, h.value) * m.value
    ), i = o(() => l[e.size] * m.value);
    return (y, a) => (g(), b("g", {
      transform: `rotate(${-y.rotation}, ${d.value.x}, ${d.value.y})`
    }, [
      y.border ? (g(), b("rect", {
        key: 0,
        x: d.value.x - h.value / 2,
        y: d.value.y - w.value / 2 - 0.5,
        width: h.value,
        height: w.value,
        fill: v(n).labelBackground,
        stroke: v(s),
        "stroke-width": "1.5",
        rx: "6"
      }, null, 8, ue)) : W("", !0),
      $("text", {
        x: d.value.x,
        y: d.value.y,
        style: G(`font-family: monospace; font-size: ${i.value}px; dominant-baseline: middle; text-anchor: middle; font-weight: 500;`),
        fill: v(s)
      }, U(y.text), 13, de)
    ], 8, ie));
  }
}), H = 2 * Math.PI, E = Math.PI / 180, ce = ["d", "fill"], he = ["d", "stroke-width", "stroke", "stroke-dasharray"], J = /* @__PURE__ */ M({
  __name: "Angle",
  props: {
    color: {},
    fill: {},
    radius: { default: 1 },
    a: {},
    b: {},
    c: {},
    dashed: { type: Boolean, default: !1 },
    lineWidth: { default: 1.5 },
    label: {},
    labelSize: { default: "small" }
  },
  setup(f) {
    const e = f, { scale: l, offset: c, invScale: u } = P(), { parseColor: p } = B(), m = p(_(e, "color"), "stroke"), n = p(_(e, "fill")), r = o(() => t.wrap(e.a)), s = o(() => t.wrap(e.b)), d = o(() => t.wrap(e.c)), h = o(() => s.value.x * (d.value.y - r.value.y) + r.value.x * (s.value.y - d.value.y) + d.value.x * (r.value.y - s.value.y) > 0 ? 1 : 0), w = o(
      () => s.value.mul(new t(1, -1)).mul(l.value).add(c.value)
    ), i = o(() => e.radius * l.value.x), y = o(() => {
      const x = r.value.sub(s.value).normalized().mul(new t(1, -1));
      return s.value.mul(new t(1, -1)).add(x.scale(e.radius)).mul(l.value).add(c.value);
    }), a = o(() => {
      const x = d.value.sub(s.value).normalized().mul(new t(1, -1));
      return s.value.mul(new t(1, -1)).add(x.scale(e.radius)).mul(l.value).add(c.value);
    }), k = o(
      () => e.dashed ? [6 * u.value, 4 * u.value].join(",") : "0,0"
    ), z = o(() => {
      const x = r.value.sub(s.value), S = d.value.sub(s.value), C = x.dot(S), D = x.x * S.y - x.y * S.x, K = (Math.atan2(D, C) + H) % H;
      return x.normalized().scale(e.radius).rotate(K / 2).add(s.value);
    });
    return (x, S) => (g(), b("g", null, [
      v(n) ? (g(), b("path", {
        key: 0,
        d: `M ${w.value.x} ${w.value.y} L ${y.value.x} ${y.value.y} A ${i.value} ${i.value} 0 ${h.value} 0 ${a.value.x} ${a.value.y}`,
        stroke: "none",
        fill: v(n)
      }, null, 8, ce)) : W("", !0),
      $("path", {
        d: `M ${y.value.x} ${y.value.y} A ${i.value} ${i.value} 0 ${h.value} 0 ${a.value.x} ${a.value.y}`,
        "stroke-width": x.lineWidth * v(u),
        stroke: v(m),
        "stroke-dasharray": k.value,
        fill: "none"
      }, null, 8, he),
      x.label ? (g(), j(F, {
        key: 1,
        text: x.label,
        position: z.value,
        color: x.color,
        size: x.labelSize
      }, null, 8, ["text", "position", "color", "size"])) : W("", !0)
    ]));
  }
}), Fe = /* @__PURE__ */ M({
  __name: "Arc",
  props: {
    position: { default: () => new t() },
    from: { default: 0 },
    to: {},
    radius: { default: 3 },
    color: {},
    dashed: { type: Boolean, default: !1 },
    lineWidth: { default: 1.25 },
    radians: { type: Boolean, default: !1 },
    label: {},
    labelSize: { default: "small" }
  },
  setup(f) {
    const e = f, { colors: l } = B(), c = o(() => e.color ?? l.value.stroke), u = o(() => t.wrap(e.position)), p = o(() => {
      const n = e.radians ? e.from : e.from * E;
      return t.fromAngle(n).add(u.value);
    }), m = o(() => {
      const n = e.radians ? e.to : e.to * E;
      return t.fromAngle(n).add(u.value);
    });
    return (n, r) => (g(), j(J, {
      a: p.value,
      b: u.value,
      c: m.value,
      radius: n.radius,
      dashed: n.dashed,
      "line-width": n.lineWidth,
      color: c.value,
      label: n.label,
      "label-size": n.labelSize
    }, null, 8, ["a", "b", "c", "radius", "dashed", "line-width", "color", "label", "label-size"]));
  }
}), ve = ["cx", "cy", "r", "fill", "stroke", "stroke-width", "stroke-dasharray"], Te = /* @__PURE__ */ M({
  __name: "Circle",
  props: {
    radius: {},
    color: {},
    fill: {},
    position: { default: () => new t() },
    dashed: { type: Boolean, default: !1 },
    lineWidth: { default: 1.5 }
  },
  setup(f) {
    const e = f, { scale: l, offset: c, invScale: u } = P(), { parseColor: p } = B(), m = p(_(e, "color"), "stroke"), n = p(_(e, "fill")), r = o(
      () => new t(e.position).mul(new t(1, -1)).mul(l.value).add(c.value)
    ), s = o(() => e.radius * l.value.x), d = o(
      () => e.dashed ? [6 * u.value, 4 * u.value].join(",") : "0,0"
    );
    return (h, w) => (g(), b("circle", {
      cx: r.value.x,
      cy: r.value.y,
      r: s.value,
      fill: v(n),
      stroke: v(m),
      "stroke-width": h.lineWidth * v(u),
      "stroke-dasharray": d.value
    }, null, 8, ve));
  }
}), fe = ["cx", "cy", "rx", "ry", "fill", "stroke", "stroke-width", "stroke-dasharray", "transform"], Ge = /* @__PURE__ */ M({
  __name: "Ellipse",
  props: {
    radius: { default: () => new t(1, 1) },
    color: {},
    fill: {},
    position: { default: () => new t() },
    dashed: { type: Boolean, default: !1 },
    lineWidth: { default: 1.5 },
    rotation: { default: 0 },
    radians: { type: Boolean, default: !1 }
  },
  setup(f) {
    const e = f, { offset: l, scale: c, invScale: u } = P(), { parseColor: p } = B(), m = p(_(e, "color"), "stroke"), n = p(_(e, "fill")), r = o(
      () => new t(e.position).mul(new t(1, -1)).mul(c.value).add(l.value)
    ), s = o(() => new t(e.radius).mul(c.value)), d = o(
      () => e.dashed ? [6 * u.value, 4 * u.value].join(",") : "0,0"
    ), h = o(
      () => e.radians ? e.rotation * 180 / Math.PI : e.rotation
    );
    return (w, i) => (g(), b("ellipse", {
      cx: r.value.x,
      cy: r.value.y,
      rx: s.value.x,
      ry: s.value.y,
      fill: v(n),
      stroke: v(m),
      "stroke-width": w.lineWidth * v(u),
      "stroke-dasharray": d.value,
      transform: `rotate(${-h.value}, ${r.value.x}, ${r.value.y})`
    }, null, 8, fe));
  }
}), pe = ["d", "stroke", "stroke-width"], Ue = /* @__PURE__ */ M({
  __name: "FunctionPlot",
  props: {
    function: {},
    step: { default: 0.1 },
    color: {},
    animated: { type: Boolean, default: !1 },
    domain: {},
    lineWidth: { default: 1.25 },
    end: { default: 1 / 0 }
  },
  setup(f) {
    const e = f;
    let l = null;
    const { domain: c, scale: u, offset: p, size: m, invScale: n } = P(), { parseColor: r } = B(), s = r(_(e, "color"), "stroke"), d = R([]), h = o(
      () => e.domain ? new t(e.domain) : c.value.x
    ), w = o(() => {
      const z = Math.abs(h.value.x - h.value.y) / m.value.x, x = Math.ceil((e.end - h.value.x) / z);
      return d.value.slice(0, x);
    }), i = o(() => {
      const k = w.value;
      return k.length === 0 ? "" : `M ${k[0].x * u.value.x + p.value.x} ${k[0].y * u.value.y + p.value.y} L ${k.slice(1).map(
        (z) => `${z.x * u.value.x + p.value.x} ${z.y * u.value.y + p.value.y}`
      ).join("L ")}`;
    });
    function y() {
      const k = Date.now();
      d.value = [];
      const x = Math.abs(h.value.x - h.value.y) / m.value.x;
      for (let S = 0; S <= m.value.x; S++) {
        const C = h.value.x + S * x, D = e.function(C, k);
        d.value.push(new t(C, -D));
      }
    }
    function a() {
      y(), l = requestAnimationFrame(a);
    }
    return O(() => {
      y(), e.animated && a();
    }), le(
      () => e.animated,
      (k) => {
        k ? a() : l && (cancelAnimationFrame(l), l = null);
      }
    ), (k, z) => (g(), b("path", {
      d: i.value,
      fill: "none",
      stroke: v(s),
      "stroke-width": k.lineWidth * v(n)
    }, null, 8, pe));
  }
}), ye = ["viewBox", "width", "height"], me = ["id"], we = ["width", "height"], xe = ["id", "width", "height"], ge = ["d", "stroke", "stroke-width"], ke = ["width", "height", "fill"], $e = ["x1", "x2", "y2", "stroke", "stroke-width"], be = ["y1", "x2", "y2", "stroke", "stroke-width"], ze = ["x1", "y1", "x2", "y2", "stroke", "stroke-width"], Se = ["x", "y", "fill"], _e = ["x1", "y1", "x2", "y2", "stroke", "stroke-width"], Me = ["x", "y", "fill"], Be = ["clip-path"], Ye = /* @__PURE__ */ M({
  __name: "Graph",
  props: {
    width: { default: 300 },
    height: { default: 300 },
    padding: { default: 30 },
    gridSize: { default: 1 },
    origin: {},
    domainX: { default: () => new t(-5, 5) },
    domainY: { default: () => new t(-5, 5) },
    axis: { type: Boolean, default: !0 },
    grid: { type: Boolean, default: !0 },
    units: { type: Boolean, default: !0 }
  },
  setup(f) {
    const e = f, l = Math.random().toString(16).slice(2), { colors: c } = B(), u = R(), p = R(new t(e.width, e.height)), m = o(() => e.origin ? new t(e.origin) : new t(
      (n.value.x.y - n.value.x.x) / 2,
      (n.value.y.y - n.value.y.x) / 2
    )), n = o(() => ({
      x: new t(e.domainX),
      y: new t(e.domainY)
    })), r = o(() => m.value.mul(s.value)), s = o(
      () => new t(
        e.width / Math.abs(n.value.x.x - n.value.x.y),
        e.height / Math.abs(n.value.y.x - n.value.y.y)
      )
    ), d = o(() => e.width / e.height), h = o(() => {
      const a = Math.min(e.width, p.value.x), k = a / d.value;
      return new t(a, k);
    }), w = o(() => Math.max(1, e.width / h.value.x));
    ae(N, {
      size: h,
      scale: s,
      origin: m,
      offset: r,
      domain: n,
      invScale: w
    });
    function y(a) {
      return a.toFixed(2).replace(/\.?0+$/, "");
    }
    return O(() => {
      new ResizeObserver((k) => {
        const x = k[0].contentBoxSize[0];
        p.value.x = x.inlineSize, p.value.y = x.blockSize;
      }).observe(u.value.parentElement);
    }), (a, k) => (g(), b("svg", {
      ref_key: "el",
      ref: u,
      viewBox: `${-a.padding} ${-a.padding} ${a.width + a.padding * 2} ${a.height + a.padding * 2}`,
      width: h.value.x,
      height: h.value.y,
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      $("defs", null, [
        $("clipPath", {
          id: `clip-${v(l)}`
        }, [
          $("rect", {
            x: "0",
            y: "0",
            width: a.width,
            height: a.height
          }, null, 8, we)
        ], 8, me)
      ]),
      a.grid ? (g(), b(A, { key: 0 }, [
        $("defs", null, [
          $("pattern", {
            id: v(l),
            width: s.value.x * a.gridSize,
            height: s.value.y * a.gridSize,
            patternUnits: "userSpaceOnUse"
          }, [
            $("path", {
              d: `M 0 0 L 0 ${s.value.y * a.gridSize} ${s.value.x * a.gridSize} ${s.value.y * a.gridSize} ${s.value.x * a.gridSize} 0 0 0`,
              fill: "none",
              stroke: v(c).grid,
              "stroke-width": 0.75 * w.value
            }, null, 8, ge)
          ], 8, xe)
        ]),
        $("rect", {
          width: a.width,
          height: a.height,
          fill: `url(#${v(l)})`
        }, null, 8, ke)
      ], 64)) : W("", !0),
      a.axis ? (g(), b(A, { key: 1 }, [
        $("line", {
          x1: r.value.x,
          y1: 0,
          x2: r.value.x,
          y2: a.height,
          stroke: v(c).axis,
          "stroke-width": 1.5 * w.value
        }, null, 8, $e),
        $("line", {
          x1: 0,
          y1: r.value.y,
          x2: a.width,
          y2: r.value.y,
          stroke: v(c).axis,
          "stroke-width": 1.5 * w.value
        }, null, 8, be)
      ], 64)) : W("", !0),
      a.units ? (g(), b(A, { key: 2 }, [
        (g(!0), b(A, null, Y(Math.floor(Math.abs(n.value.x.x - n.value.x.y) / a.gridSize) + 1, (z) => (g(), b(A, null, [
          $("line", {
            x1: s.value.x * (z - 1) * a.gridSize,
            y1: r.value.y,
            x2: s.value.x * (z - 1) * a.gridSize,
            y2: r.value.y + 5,
            stroke: v(c).units,
            "stroke-width": 1 * w.value
          }, null, 8, ze),
          $("text", {
            x: s.value.x * (z - 1) * a.gridSize,
            y: r.value.y + 14,
            style: G(`
            dominant-baseline: middle;
            text-anchor: middle;
            font-size: ${12 * w.value}px;
            font-family: sans-serif;
          `),
            fill: v(c).units
          }, U(y((z - 1) * a.gridSize - m.value.x)), 13, Se)
        ], 64))), 256)),
        (g(!0), b(A, null, Y(Math.floor(Math.abs(n.value.y.x - n.value.y.y) / a.gridSize) + 1, (z) => (g(), b(A, null, [
          $("line", {
            x1: r.value.x,
            y1: s.value.y * (z - 1) * a.gridSize,
            x2: r.value.x - 5,
            y2: s.value.y * (z - 1) * a.gridSize,
            stroke: v(c).units,
            "stroke-width": 1 * w.value
          }, null, 8, _e),
          $("text", {
            x: r.value.x - 14,
            y: s.value.y * (z - 1) * a.gridSize,
            style: G(`
            dominant-baseline: middle;
            text-anchor: middle;
            font-size: ${12 * w.value}px;
            font-family: sans-serif;
          `),
            fill: v(c).units
          }, U(y(m.value.y - (z - 1) * a.gridSize)), 13, Me)
        ], 64))), 256))
      ], 64)) : W("", !0),
      $("g", {
        "clip-path": `url(#clip-${v(l)})`
      }, [
        oe(a.$slots, "default")
      ], 8, Be)
    ], 8, ye));
  }
}), Ae = ["x1", "y1", "x2", "y2", "stroke", "stroke-width", "stroke-dasharray"], qe = /* @__PURE__ */ M({
  __name: "Line",
  props: {
    slope: {},
    yIntercept: { default: 0 },
    from: {},
    to: {},
    color: {},
    dashed: { type: Boolean, default: !1 },
    lineWidth: { default: 1.75 },
    label: {},
    labelSize: { default: "small" }
  },
  setup(f) {
    const e = f;
    if (e.to === void 0 && e.slope === void 0)
      throw new Error("Line requires either a `to` prop or a `slope` prop");
    const { domain: l, scale: c, offset: u, invScale: p } = P(), { parseColor: m } = B(), n = m(_(e, "color"), "stroke");
    function r(i, y, a) {
      return Math.min(a, Math.max(y, i));
    }
    const s = o(() => {
      if (e.from)
        return new t(e.from).mul(new t(1, -1)).mul(c.value).add(u.value);
      if (e.to)
        return new t(0, 0).mul(new t(1, -1)).mul(c.value).add(u.value);
      let i = (l.value.y.x - e.yIntercept) / e.slope;
      i = r(i, l.value.x.x, l.value.x.y);
      const y = e.slope * i + e.yIntercept;
      return new t(i, y).mul(new t(1, -1)).mul(c.value).add(u.value);
    }), d = o(() => {
      if (e.to)
        return new t(e.to).mul(new t(1, -1)).mul(c.value).add(u.value);
      let i = (l.value.y.y - e.yIntercept) / e.slope;
      i = r(i, l.value.x.x, l.value.x.y);
      const y = e.slope * i + e.yIntercept;
      return new t(i, y).mul(new t(1, -1)).mul(c.value).add(u.value);
    }), h = o(() => {
      const i = s.value.sub(u.value).div(c.value).mul(new t(1, -1)), a = d.value.sub(u.value).div(c.value).mul(new t(1, -1)).sub(i);
      return i.add(a.normalized().scale(a.length() / 2));
    }), w = o(
      () => e.dashed ? [6 * p.value, 4 * p.value].join(",") : "0,0"
    );
    return (i, y) => (g(), b(A, null, [
      $("line", {
        x1: s.value.x,
        y1: s.value.y,
        x2: d.value.x,
        y2: d.value.y,
        stroke: v(n),
        "stroke-width": i.lineWidth * v(p),
        "stroke-dasharray": w.value
      }, null, 8, Ae),
      i.label ? (g(), j(F, {
        key: 0,
        text: i.label,
        position: h.value,
        color: v(n),
        size: i.labelSize
      }, null, 8, ["text", "position", "color", "size"])) : W("", !0)
    ], 64));
  }
}), Pe = ["cx", "cy", "r", "fill", "stroke", "stroke-width"], I = 25, He = /* @__PURE__ */ M({
  __name: "Point",
  props: {
    radius: { default: 4 },
    color: {},
    position: { default: () => new t() },
    labelPosition: { default: "bottom" },
    label: {},
    filled: { type: Boolean, default: !0 },
    lineWidth: { default: 1.5 }
  },
  setup(f) {
    const e = f, { scale: l, offset: c, invScale: u } = P(), { parseColor: p } = B(), m = p(_(e, "color"), "points"), n = o(() => new t(e.position)), r = o(
      () => n.value.mul(new t(1, -1)).mul(l.value).add(c.value)
    ), s = o(() => {
      switch (e.labelPosition) {
        case "top":
          return new t(
            n.value.x,
            n.value.y + I / l.value.y
          );
        case "bottom":
          return new t(
            n.value.x,
            n.value.y - I / l.value.y
          );
        case "left":
          return new t(
            n.value.x - I / l.value.x,
            n.value.y
          );
        case "right":
          return new t(
            n.value.x + I / l.value.x,
            n.value.y
          );
      }
    });
    return (d, h) => (g(), b(A, null, [
      $("circle", {
        cx: r.value.x,
        cy: r.value.y,
        r: d.radius,
        fill: d.filled ? v(m) : "none",
        stroke: d.filled ? "none" : v(m),
        "stroke-width": d.lineWidth * v(u)
      }, null, 8, Pe),
      d.label ? (g(), j(F, {
        key: 0,
        text: d.label,
        position: s.value,
        color: v(m),
        size: "small"
      }, null, 8, ["text", "position", "color"])) : W("", !0)
    ], 64));
  }
}), We = ["points", "stroke", "stroke-width", "fill"], Oe = /* @__PURE__ */ M({
  __name: "Polygon",
  props: {
    vertices: {},
    color: {},
    fill: {},
    lineWidth: { default: 1.25 },
    angles: { type: Boolean, default: !1 },
    angleRadius: { default: 1 },
    angleDashed: { type: Boolean, default: !0 }
  },
  setup(f) {
    const e = f;
    if (e.vertices.length < 3)
      throw new Error("A polygon must have at least 3 vertices");
    const { scale: l, offset: c, invScale: u } = P(), { parseColor: p } = B(), m = p(_(e, "color"), "stroke"), n = p(_(e, "fill")), r = o(() => e.vertices.map((h) => t.wrap(h))), s = o(
      () => r.value.map(
        (h) => h.mul(new t(1, -1)).mul(l.value).add(c.value)
      )
    ), d = o(() => {
      const h = [];
      for (let w = 0; w < r.value.length; w++) {
        const i = r.value[(w - 1 + r.value.length) % r.value.length], y = r.value[w], a = r.value[(w + 1) % r.value.length];
        h.push({ a: i, b: y, c: a });
      }
      return h;
    });
    return (h, w) => (g(), b(A, null, [
      $("polygon", {
        points: `${s.value.map((i) => `${i.x},${i.y}`).join(" ")}`,
        stroke: v(m),
        "stroke-width": h.lineWidth * v(u),
        fill: v(n)
      }, null, 8, We),
      e.angles ? (g(!0), b(A, { key: 0 }, Y(d.value, (i) => (g(), j(J, {
        a: i.a,
        b: i.b,
        c: i.c,
        radius: h.angleRadius,
        dashed: h.angleDashed
      }, null, 8, ["a", "b", "c", "radius", "dashed"]))), 256)) : W("", !0)
    ], 64));
  }
}), Ce = ["d", "stroke-width", "stroke", "stroke-dasharray"], Ne = /* @__PURE__ */ M({
  __name: "PolyLine",
  props: {
    points: {},
    color: {},
    lineWidth: { default: 1.5 },
    dashed: { type: Boolean, default: !1 }
  },
  setup(f) {
    const e = f, { scale: l, offset: c, invScale: u } = P(), { parseColor: p } = B(), m = p(_(e, "color"), "stroke"), n = o(
      () => e.points.map(
        (s) => t.wrap(s).mul(new t(1, -1)).mul(l.value).add(c.value)
      )
    ), r = o(
      () => e.dashed ? [6 * u.value, 4 * u.value].join(",") : "0,0"
    );
    return (s, d) => (g(), b("path", {
      d: `M ${n.value[0].x} ${n.value[0].y} L ${n.value.slice(1).map((h) => `${h.x} ${h.y}`).join(" ")}`,
      "stroke-width": s.lineWidth * v(u),
      stroke: v(m),
      "stroke-dasharray": r.value,
      fill: "none"
    }, null, 8, Ce));
  }
}), Le = ["d", "stroke", "stroke-width", "fill", "stroke-dasharray"], Xe = /* @__PURE__ */ M({
  __name: "Sector",
  props: {
    color: {},
    fill: {},
    radius: { default: 1 },
    position: { default: () => new t() },
    from: { default: 0 },
    to: {},
    dashed: { type: Boolean, default: !1 },
    lineWidth: { default: 1.5 },
    radians: { type: Boolean, default: !1 }
  },
  setup(f) {
    const e = f, { scale: l, offset: c, invScale: u } = P(), { color: p, fill: m } = ne(e), { parseColor: n } = B(), r = n(p, "stroke"), s = n(m), d = o(
      () => t.wrap(e.position).mul(new t(1, -1)).mul(l.value).add(c.value)
    ), h = o(() => e.radius * l.value.x), w = o(
      () => e.radians ? e.from : e.from * E
    ), i = o(() => e.radians ? e.to : e.to * E), y = o(
      () => t.fromPolar(w.value, h.value).mul(new t(1, -1)).add(d.value)
    ), a = o(
      () => t.fromPolar(i.value, h.value).mul(new t(1, -1)).add(d.value)
    ), k = o(
      () => e.dashed ? [6 * u.value, 4 * u.value].join(",") : "0,0"
    ), z = o(() => {
      const x = a.value, S = d.value, C = y.value;
      return S.x * (C.y - x.y) + x.x * (S.y - C.y) + C.x * (x.y - S.y) > 0 ? 1 : 0;
    });
    return (x, S) => (g(), b("path", {
      d: `M ${d.value.x} ${d.value.y} L ${y.value.x} ${y.value.y} A ${h.value} ${h.value} 0 ${z.value} 0 ${a.value.x} ${a.value.y} L ${d.value.x} ${d.value.y} z`,
      stroke: v(r),
      "stroke-width": x.lineWidth * v(u),
      "stroke-linejoin": "bevel",
      fill: v(s),
      "stroke-dasharray": k.value
    }, null, 8, Le));
  }
}), je = ["id", "refY", "markerWidth", "markerHeight"], De = ["points", "fill"], Ie = ["x1", "y1", "x2", "y2", "stroke-width", "stroke", "stroke-dasharray", "marker-end"], Je = /* @__PURE__ */ M({
  __name: "Vector",
  props: {
    from: { default: () => new t() },
    to: {},
    color: {},
    dashed: { type: Boolean, default: !1 },
    label: {},
    labelSize: { default: "normal" },
    lineWidth: { default: 1.75 },
    arrowSize: { default: 18 }
  },
  setup(f) {
    const e = f, l = Math.random().toString(16).slice(2), { scale: c, offset: u, invScale: p } = P(), { colors: m } = B(), n = o(() => e.color ?? m.value.stroke), r = o(
      () => t.wrap(e.to).sub(e.from).mul(c.value)
    ), s = o(
      () => new t(e.from).mul(new t(1, -1)).mul(c.value).add(u.value)
    ), d = o(() => {
      const y = r.value.angle, k = r.value.length() - i.value;
      return new t(
        s.value.x + k * Math.cos(y),
        s.value.y - k * Math.sin(y)
      );
    }), h = o(() => {
      const y = t.wrap(e.from), a = t.wrap(e.to).sub(y);
      return y.add(a.normalized().scale(a.length() / 2));
    }), w = o(
      () => e.dashed ? [6 * p.value, 4 * p.value].join(",") : "0,0"
    ), i = o(
      () => Math.min(e.arrowSize, r.value.length() / 2) * p.value
    );
    return (y, a) => (g(), b(A, null, [
      $("defs", null, [
        $("marker", {
          id: v(l),
          refY: i.value / 3,
          markerWidth: i.value,
          markerHeight: i.value / 1.5,
          orient: "auto",
          markerUnits: "userSpaceOnUse"
        }, [
          $("polygon", {
            points: `0 0, ${i.value} ${i.value / 3}, 0 ${i.value / 1.5}`,
            fill: n.value
          }, null, 8, De)
        ], 8, je)
      ]),
      $("line", {
        x1: s.value.x,
        y1: s.value.y,
        x2: d.value.x,
        y2: d.value.y,
        "stroke-width": y.lineWidth * v(p),
        stroke: n.value,
        "stroke-dasharray": w.value,
        "marker-end": `url(#${v(l)})`
      }, null, 8, Ie),
      y.label ? (g(), j(F, {
        key: 0,
        text: y.label,
        position: h.value,
        color: n.value,
        size: y.labelSize
      }, null, 8, ["text", "position", "color", "size"])) : W("", !0)
    ], 64));
  }
});
function Ke(f) {
  f.colors && (L.light = { ...L.light, ...f.colors.light }, L.dark = { ...L.dark, ...f.colors.dark }), f.darkMode !== void 0 && (q.value = f.darkMode);
}
export {
  J as Angle,
  Fe as Arc,
  Te as Circle,
  Ge as Ellipse,
  Ue as FunctionPlot,
  Ye as Graph,
  F as Label,
  qe as Line,
  He as Point,
  Ne as PolyLine,
  Oe as Polygon,
  Xe as Sector,
  Je as Vector,
  t as Vector2,
  Ke as configureGraphs,
  B as useColors
};
